// extracted by mini-css-extract-plugin
export default {"item":"Tile_item__iRtQZ","input":"Tile_input__BkW8m","content":"Tile_content__ySH13","icon":"Tile_icon__JPqfi","title":"Tile_title__t4YPZ","description":"Tile_description__blOWp"};